<div class="bbva-content">
    <div class="bbva-header">
    </div>
    <div class="dialog-contnet">
        <div class="d-flex align-items-center justify-content-center mt-2 mb-2">
            <img src="./assets/icons/payment_methods/bbvamulti.svg" class="mr-2" alt="bbva logo" height="30">
            <img src="./assets/icons/padlock.svg" alt="padlock" height="15">
        </div>
        <p class="text-size-2 mb-0 text-center">¿Está seguro que quiere eliminar tarjeta?</p>
        <p class="text-size-1 mb-0 text-center">Terminación **** **** **** {{cardNumber}}</p>

        <div class="gap-10 width-100 mt-3 mb-2 d-flex flex-column align-items-center flex-md-row">
            <button mat-raised-button color="primary"
                class="font-omicron-bold blue-button font-size-button width-100" (click)="delete()">
                Eliminar
            </button>

            <button mat-stroked-button class="white-button width-100 ml-0" type="button" color="primary"
                matDialogClose>
                Cancelar
            </button>
        </div>
    </div>
</div>